import { CALC_SOURCES, COLUMN_CATALOG } from '../lib/constants'

export const SORT_DIRECTION_OPTIONS = [
  { value: 'desc', label: 'Descending (highest first)' },
  { value: 'asc', label: 'Ascending (lowest first)' }
]

export const DRAG_TYPE = 'COLUMN_ITEM'

/** Detail panel section titles for derived column dependencyOptions[calcSource] */
export const DERIVED_DEP_SOURCE_SECTION_TITLE = {
  marketValue: 'Market value',
  aip: 'Alternatives investment profile (AIP)'
}

export function groupCatalogByCategory () {
  const groups = []
  const seen = new Map()
  for (const entry of COLUMN_CATALOG) {
    if (!seen.has(entry.category)) {
      const group = { category: entry.category, items: [] }
      seen.set(entry.category, group)
      groups.push(group)
    }
    seen.get(entry.category).items.push(entry)
  }
  return groups
}

export const CATALOG_GROUPS = groupCatalogByCategory()

export function uniqueCalcSourcesFromInputs (calcInputs) {
  const seen = new Set()
  const out = []
  for (const input of calcInputs || []) {
    if (input?.source && !seen.has(input.source)) {
      seen.add(input.source)
      out.push(input.source)
    }
  }
  return out
}

/** True if at least one calc source has date settings or a non-empty settingsSchema (e.g. DVPI / AIP-only has none). */
export function derivedHasOverrideableSources (uniqueSources) {
  for (const sourceName of uniqueSources) {
    const src = CALC_SOURCES[sourceName]
    if (!src) continue
    if (src.supportsDate || (src.settingsSchema?.length ?? 0) > 0) return true
  }
  return false
}

export function getDateHint (options) {
  if (!options?.dateMode || options.dateMode === 'default') return null
  if (options.dateMode === 'quickDate' && options.quickDate) return options.quickDate
  if (options.dateMode === 'dateRange') return 'Custom'
  return null
}

export function parseDateModeValue (value) {
  if (!value || value === 'default') return { dateMode: 'default', quickDate: null }
  if (value === 'dateRange') return { dateMode: 'dateRange', quickDate: null }
  if (value.startsWith('qd:')) return { dateMode: 'quickDate', quickDate: value.slice(3) }
  return { dateMode: 'default', quickDate: null }
}

export function toDateModeSelectValue (options) {
  if (!options?.dateMode || options.dateMode === 'default') return 'default'
  if (options.dateMode === 'dateRange') return 'dateRange'
  if (options.dateMode === 'quickDate' && options.quickDate) return `qd:${options.quickDate}`
  return 'default'
}
